<template>
  <div>
    <plan-change-step1 v-if="step===1" @next="step=2" :hosting="hosting" :service="service"
                       :base-trial-product.sync="trial_product"
                       :selector-stocks="selectorStocks" :baseOrderProduct.sync="order_product"
                       @close="$emit('close')"></plan-change-step1>
    <plan-change-step2 v-else-if="step===2" @next="step=3" :hosting="hosting" :service="service"
                       :trial_product="trial_product"
                       :selector-stocks="selectorStocks" :order_product="order_product" @close="$emit('close')"
                       @updatePlan="updatePlan"></plan-change-step2>
    <plan-change-step3 v-else-if="step===3" :hosting="hosting" :service="service" :trial_product="trial_product"
                       :selector-stocks="selectorStocks" :order_product="order_product"
                       @close="$emit('done')"></plan-change-step3>
    <plan-update-modal v-else-if="step===10" :service="service" :order_product="order_product"
                       :selector-stocks="selectorStocks"
                       @close="$emit('close')" @done="$emit('done')"></plan-update-modal>
    <service-recover-modal v-else-if="step===11" :service="service" :order_product="order_product"
                           :selector-stocks="selectorStocks"
                           @close="$emit('close')" @done="$emit('done')"></service-recover-modal>
  </div>
</template>
<script>
  import PlanChangeStep1 from "./PlanChangeStep1";
  import PlanChangeStep2 from "./PlanChangeStep2";
  import PlanChangeStep3 from "./PlanChangeStep3";
  import PlanUpdateModal from "./PlanUpdateModal";
  import ServiceRecoverModal from "./ServiceRecoverModal";

  export default {
    name: "PlanChange",
    components: {
      ServiceRecoverModal,
      PlanUpdateModal,
      PlanChangeStep3,
      PlanChangeStep2,
      PlanChangeStep1
    },
    created() {
      this.getHosting();
      this.getLaunchpackService();

    },
    data() {
      return {
        step: 0,
        hosting: undefined,
        service: undefined,
        selectorStocks: [],
        order_product: undefined,
        trial_product: {
          month_free: false,
          app_porting: false
        }
      }
    },
    computed: {},
    methods: {
      updatePlan() {
        if(this.service.status===10) this.step=11
        else this.step=10
      },
      getData() {
        this.$axios.get(`https://master-dev.launchpack.co.kr:1111/public/launchpack/v1/theme/174`).then(async res => {
          if (res.status === 200) {
            this.order_product = {
              product_id: res.data.id,
              quantity: 1,
              discount_price: 0,
              product_price: 0,
              total_price: 0,
              product: res.data,
              order_product_option: [],
              required_option_price: 0,
              add_option_price: 0,
              date_unit: 1
            }
            this.$axios.get('https://master-dev.launchpack.co.kr:1111/public/launchpack/service_plan').then(plan_res => {
              res.data.selectors[0].options.forEach(item => {
                let plan = plan_res.data.filter(plan => {
                  return plan.membership === item.name;
                })[0];
                const tb = {
                  user: {index: 1, kor: '회원가입 수', unit: '명', tag: ''},
                  product: {index: 2, kor: '상품 등록 수', unit: '건', tag: ''},
                  category: {index: 3, kor: '상품 카테고리 수', unit: '개', tag: ''},
                  partner: {index: 4, kor: '파트너 등록 수', unit: '건', tag: ''},
                  admin_account: {index: 5, kor: '관리자 계정 갯수', unit: '명', tag: ''},
                  front: {index: 6, kor: '프론트 서비스 제공 범위', unit: '', tag: ''},
                  template: {index: 7, kor: '블럭템플릿 무제한 이용권', unit: '',
                    tag: '디자인 수정 시 런치팩의 디자인 템플릿을 무제한으로 이용할 수 있습니다.'}
                };

                item.plan = Object.keys(plan.usage).map(key => {
                  return {
                    index: tb[key].index,
                    name: tb[key].kor,
                    text: plan.usage[key] + tb[key].unit,
                    tag: tb[key].tag
                  }
                }).sort((a, b) => {
                  return a.index - b.index
                });
                this.getSelectorStocks();
              });
            });
          }
        });
      },
      getSelectorStocks() {
        let url = this.masterBackendUrl + `public/product/${this.order_product.product.id}/selector_stocks`
        this.$axios.post(url).then(res => {
          this.selectorStocks = res.data.stocks;
          this.step = 1;
        })
      },
      getHosting() {
        this.$axios.get(this.masterBackendUrl + 'public/launchpack/hosting').then(res => {
          let list = res.data;
          list = list.filter(item => {
            return item.name === 'BASIC'
          })
          if (list.length === 1) this.hosting = list[0];
        })
      },
      getLaunchpackService() {
        this.$axios.get('admin/launchpack/service/info').then(res => {
          this.service = res.data;
          this.getData();
        })
      },
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
